// src/core/main.jsx
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '../index.css'; // Ajustamos ruta al subir un nivel
import App from '../App.jsx';
import reportWebVitals from './reportWebVitals';

// 1. Manejo de errores de carga de chunks (Infrastructure)
window.addEventListener('vite:preloadError', (event) => {
  console.log("Detectado error al cargar módulo dinámico (chunk). Recargando...");
  const isRefreshed = sessionStorage.getItem('vite-chunk-failed');
  if (!isRefreshed) {
    sessionStorage.setItem('vite-chunk-failed', 'true');
    window.location.reload();
  }
});

// 2. Registro de Service Worker para Firebase Messaging
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("Service Worker registrado para FCM:", registration);
    })
    .catch((err) => {
      console.error("Error registrando el Service Worker de FCM:", err);
    });
}

// 3. Renderizado Único
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

// 4. Medición de rendimiento
reportWebVitals();